export default __webpack_public_path__ + "static/media/union.013246fb.svg";